import type {
  MemoryFeastAction,
  MemoryFeastPhase,
  MemoryFeastState,
  OpenBowlsAction,
  PlaceTokensAction,
} from "../types";
import { MEMORY_FEAST_PLACEMENT_ROUNDS } from "../types";
import { addTokens, getOpponentPlayerId, setBowlsOpen } from "../utils";

export function applyPlaceTokens(
  state: MemoryFeastState,
  action: PlaceTokensAction,
): MemoryFeastState {
  const bowls = addTokens(state.bowls, action.bowlIds);
  const isSecondPlacement = action.playerId !== state.firstPlayerId;

  let phase: MemoryFeastPhase = state.phase;
  let round = state.round;
  let currentPlayerId = getOpponentPlayerId(action.playerId);

  if (isSecondPlacement) {
    // Both players have placed this round; advance.
    currentPlayerId = state.firstPlayerId;
    if (state.phase === "place") {
      if (round < MEMORY_FEAST_PLACEMENT_ROUNDS) {
        round += 1;
      } else {
        phase = "place-bonus";
      }
    } else {
      // place-bonus complete → open phase.
      phase = "open";
    }
  }

  return {
    ...state,
    bowls,
    phase,
    round,
    currentPlayerId,
    moveNumber: state.moveNumber + 1,
    lastAction: action,
  };
}

export function applyOpenBowls(
  state: MemoryFeastState,
  action: OpenBowlsAction,
): MemoryFeastState {
  const a = action.bowlIds[0] ?? 0;
  const b = action.bowlIds[1] ?? 0;
  const countA = state.bowls[a]?.count ?? 0;
  const countB = state.bowls[b]?.count ?? 0;
  const matched = countA === countB;
  const bowls = setBowlsOpen(state.bowls, [a, b]);

  return {
    ...state,
    bowls,
    phase: matched ? "game-over" : "open",
    currentPlayerId: matched
      ? action.playerId
      : getOpponentPlayerId(action.playerId),
    winnerId: matched ? action.playerId : state.winnerId,
    lastOpen: {
      playerId: action.playerId,
      bowlIds: [a, b],
      counts: [countA, countB],
      matched,
    },
    moveNumber: state.moveNumber + 1,
    lastAction: action,
  };
}

export function applyAction(
  state: MemoryFeastState,
  action: MemoryFeastAction,
): MemoryFeastState {
  switch (action.type) {
    case "PlaceTokens":
      return applyPlaceTokens(state, action);
    case "OpenBowls":
      return applyOpenBowls(state, action);
  }
}
